module.exports = __webpack_public_path__ + "img/new.22e12aee.svg";